import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { PdfExportSettings } from "@main/reporting.v3/core/reporting-models";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IGridPdfTemplateSettings } from "@main/reporting.v3/widget.grid/widget-grid.models";
import { WidgetGridAuxiliaryService } from "@main/reporting.v3/widget.grid/api/widget-grid-auxiliary.service";
import { HtmlRenderingService } from "@main/reporting.v3/core/rendering/html-rendering.service";
import { JsReportConfiguration } from "@main/pdf-exporting/js-report/js-report.models";

@Injectable()
export class WidgetGridPdfExportingService extends BaseDataService {
    readonly url: string = "api/reporting3/widget/grid/data";

    constructor(private readonly widgetGridAuxiliaryService: WidgetGridAuxiliaryService,
                private readonly htmlRenderingService: HtmlRenderingService,
                http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    public async requestPdfExport(widgetSourceId: string, settings: PdfExportSettings): Promise<string> {
        return this.httpPost(`${widgetSourceId}/pdf-export`, settings);
    }

    public async getPdfConfiguration(settings: IGridPdfTemplateSettings): Promise<JsReportConfiguration> {
        const template: string = this.getHtmlContent(settings);
        const cssRules: string = this.getCssRules();

        const footerTemplate: string = this.getFooterTemplate();
        const footerCssRules: string = this.getFooterCssRules();

        return {
            template: template,
            cssRules: cssRules,
            footerTemplate: footerTemplate,
            footerCssRules: footerCssRules,
            marginTop: 20,
            marginLeft: 20,
            marginRight: 20,
            marginBottom: 40,
        };
    }


    private getHtmlContent(settings: IGridPdfTemplateSettings): string {
        if (!settings.template || !settings.gridTableTemplate) return "";

        const parser: DOMParser = new DOMParser();
        const doc: Document = parser.parseFromString(settings.template, "text/html");

        // Add PDF view container class to widget container class list.
        doc.querySelector(this.widgetContainerSelector)?.classList?.add("pdf-view");

        const gridTable: HTMLElement = doc.querySelector(this.gridTableSelector);
        if (!gridTable) return "";

        // Replace web grid content with pdf view grid content.
        gridTable.innerHTML = settings.gridTableTemplate;

        return doc.body?.innerHTML;
    }

    private getCssRules(): string {
        const containerCssRules: string = this.htmlRenderingService.getCssRules(this.widgetContainerSelector);
        const bodyCssStyles: string = this.htmlRenderingService.getCssRules("body");
        return `${containerCssRules}\n${bodyCssStyles}`;
    }

    private getFooterTemplate(): string {
        return "<div class='widget-grid-footer pdf-view'>Page <span class='pageNumber'>" +
            "</span> of <span class='totalPages'></span></div>";
    }

    private getFooterCssRules(): string {
        return this.htmlRenderingService.getCssRules(".widget-grid-footer.pdf-view");
    }


    private get widgetContainerSelector(): string {
        return `.${this.widgetGridAuxiliaryService.widgetContainerClass}`;
    }

    private get gridTableSelector(): string {
        return `.${this.widgetGridAuxiliaryService.gridTableClass}`;
    }
}